module.exports = __webpack_public_path__ + "assets/img/gradient.3d0f067.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gradient.png
// module id = 13
// module chunks = 0